// Collapses digit-carrying segments (codes, EANs, ids) so metrics aggregate per endpoint/route instead of per entity.
export const normalizePath = (path: string): string => {
    return path
        .split('?')[0]
        .split('/')
        .map((segment) => (/\d/.test(segment) ? '{param}' : segment))
        .join('/');
};
